module.exports = {
      id: "link-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.488ce034.svg#link-usage",
      toString: function () {
        return this.url;
      }
    }